module.exports = __webpack_public_path__ + "static/media/fra.5ab43a7b.svg";